import { Switch } from "@unreserved/ui/components/switch";

export function CustomSwitch({ ...props }: React.ComponentProps<typeof Switch>) {
  return <Switch {...props} className={props.className} thumbClassName={props.thumbClassName} />;
}
